<div class="sin-value-container">
  <div class="sin-value" [style.width.rem]="6.5">{{ sin | maskSinNumber : (showFullSin$ | async)! : true }}</div>
  <div>
    <button class="eye" (click)="toggleShowFullSin(); $event.stopPropagation()">
      <img [src]="iconSrc$ | async" alt="eyeball icon" i18n-alt [style.width.rem]="1.25" [style.height.rem]="1.25" />
    </button>
  </div>
</div>
